var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-button',{attrs:{"variant":"primary"},on:{"click":function($event){return _vm.$emit('onClick')}}},[_c('feather-icon',{attrs:{"icon":"PlusIcon"}}),_vm._v(" "+_vm._s(_vm.$t('general.add'))+" ")],1)}
var staticRenderFns = []

export { render, staticRenderFns }